<template>
  <div ref="holder" :style="holderstyle" class="holder">
    <div
      ref="tlarrow"
      v-if="connector_info.tlarrow"
      class="tlarrow arrowedtext connector synaplus-cosmo-workflow-port"
    >
      <div :class="connector_info.tlarrowclasses" />
      <div :class="connector_info.tlarrowtextclasses">
        {{ connector_info.tlletter }}
      </div>
    </div>

    <div
      ref="mlarrow"
      v-if="connector_info.mlarrow"
      class="mlarrow arrowedtext connector synaplus-cosmo-workflow-port"
    >
      <div :class="connector_info.mlarrowclasses" />
      <div :class="connector_info.mlarrowtextclasses">
        {{ connector_info.mlletter }}
      </div>
    </div>

    <div
      ref="blarrow"
      v-if="connector_info.blarrow"
      class="blarrow arrowedtext connector synaplus-cosmo-workflow-port"
    >
      <div :class="connector_info.blarrowclasses" />
      <div :class="connector_info.blarrowtextclasses">
        {{ connector_info.blletter }}
      </div>
    </div>

    <div
      ref="trarrow"
      v-if="connector_info.trarrow"
      class="trarrow arrowedtext connector synaplus-cosmo-workflow-port"
    >
      <div :class="connector_info.trarrowclasses" />
      <div :class="connector_info.trarrowtextclasses">
        {{ connector_info.trletter }}
      </div>
    </div>

    <div
      ref="mrarrow"
      v-if="connector_info.mrarrow"
      class="mrarrow arrowedtext connector synaplus-cosmo-workflow-port"
    >
      <div :class="connector_info.mrarrowclasses" />
      <div :class="connector_info.mrarrowtextclasses">
        {{ connector_info.mrletter }}
      </div>
    </div>

    <div
      ref="brarrow"
      v-if="connector_info.brarrow"
      class="brarrow arrowedtext connector synaplus-cosmo-workflow-port"
    >
      <div :class="connector_info.brarrowclasses" />
      <div :class="connector_info.brarrowtextclasses">
        {{ connector_info.brletter }}
      </div>
    </div>

    <div
      ref="symbolholder"
      :id="$id('symbolholderid')"
      :class="symbolholderclasses"
    >
      <div class="presymbol">
        <span :class="connector_info.iconbackclasses" />
      </div>
      <div class="symbol">
        <span :class="connector_info.iconfrontclasses" />
      </div>
      <div v-if="value && value.has_connector_problem">
        <span class="errorsymbol fas fa-spider-black-widow" />
      </div>
    </div>

    <div v-if="postsymbol !== 'none'" class="postsymbol">
      <span
        v-if="postsymbol == 'cross'"
        class="
        fa-xs
        fa-stack
        state_indicator"
      >
        <span class="fas fa-circle fa-stack-2x text-danger" />
        <span class="fas fa-times fa-stack-1x text-white" />
      </span>
      <span
        v-if="postsymbol == 'check'"
        class="
        fa-xs
        fa-stack
        state_indicator"
      >
        <span class="fas fa-circle fa-stack-2x text-success" />
        <span class="fas fa-check fa-stack-1x text-white" />
      </span>
    </div>

    <div v-if="postsymbol_addon !== 'none'" class="postsymboladdon">
      <span
        v-if="postsymbol_addon == 'wait'"
        class="
        fa-xs
        fa-stack
        state_indicator"
      >
        <span class="fas fa-circle fa-stack-2x text-warning" />
        <span class="fas fa-cogs fa-stack-1x text-dark" />
      </span>
      <span
        v-if="postsymbol_addon == 'warn'"
        class="
        fa-xs
        fa-stack
        state_indicator"
      >
        <span class="fas fa-circle fa-stack-2x text-warning" />
        <span class="fas fa-exclamation-triangle fa-stack-1x text-dark" />
      </span>
    </div>

    <b-popover
      :target="$id('symbolholderid')"
      :content="`${brick_name}`"
      triggers="hover focus"
      placement="bottom"
    />

    <b-card
      ref="descriptionzone"
      v-if="has_description"
      :class="descriptionzoneclasses"
      :body-class="['p-1']"
    >
      {{ value.description }}
    </b-card>

    <b-progress
      v-show="!hide_progress_bar"
      :value="progress_value || 0"
      :max="100"
      variant="success"
      class="mx-1 mt-2"
      height="4px"
    />
  </div>
</template>

<!-- Keyframe border animation -->
<!-- eslint-disable-next-line max-len -->
<!-- https://stackoverflow.com/questions/28365839/dashed-border-animation-in-css3-animation -->

<style lang="scss" scoped>
@import '@/custom-bootstrap.scss';

.state_indicator {
  position: absolute;
  bottom: 25px;
  left: #{2 * $base-size + $offset}px;
  z-index: 1;
}
.holder {
  width: #{5 * $base-size}px;
  height: #{5 * $base-size}px;
  position: absolute;
  user-select: none;
  touch-action: none;
  // Required otherwise chrome does not move the font when moving the
  // background (rotating selection) cf. below
  // https://stackoverflow.com/questions/39296309/css3-transforms-appear-differently-on-safari-and-chrome
  transform-style: preserve-3d;
}
.tlarrow {
  position: absolute;
  top: #{$base-size + $offset}px;
  right: #{4 * $base-size + $offset}px;
  cursor: crosshair;
}
.mlarrow {
  position: absolute;
  top: #{2 * $base-size + $offset}px;
  right: #{4 * $base-size + $offset}px;
  cursor: crosshair;
}
.blarrow {
  position: absolute;
  top: #{3 * $base-size + $offset}px;
  right: #{4 * $base-size + $offset}px;
  cursor: crosshair;
}
.trarrow {
  position: absolute;
  top: #{$base-size + $offset}px;
  left: #{4 * $base-size + $offset}px;
  cursor: crosshair;
}
.mrarrow {
  position: absolute;
  top: #{2 * $base-size + $offset}px;
  left: #{4 * $base-size + $offset}px;
  cursor: crosshair;
}
.brarrow {
  position: absolute;
  top: #{3 * $base-size + $offset}px;
  left: #{4 * $base-size + $offset}px;
  cursor: crosshair;
}
.arrowedtext {
  font-size: #{$base-size - 2 * $offset}px;
  line-height: #{$base-size - 2 * $offset}px;
  height: #{$base-size - 2 * $offset}px;
  width: #{$base-size}px;
  height: #{$base-size}px;
}
.arrowlefttextcontainer {
  position: absolute;
  top: 0px;
  left: 7px;
  z-index: 1;
}
.arrowhead {
  position: absolute;
  border-left: 7px solid;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
  top: 0px;
  right: 1px;
  z-index: 0;
}
.arrowrighttextcontainer {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1;
}
.arrowtail {
  position: absolute;
  border-left: 7px solid transparent;
  border-top: 7px solid;
  border-bottom: 7px solid;
  border-right: 7px solid;
  top: 0px;
  left: 0px;
  z-index: 0;
}
.errorsymbol {
  position: absolute;
  top: 19px;
  left: 13px;
  font-size: 24px;
  line-height: 12px;
  height: 12px;
  width: 12px;
  text-align: center;
}

.selected {
  background: linear-gradient(90deg, #2196f3 50%, transparent 50%),
    linear-gradient(90deg, #2196f3 50%, transparent 50%),
    linear-gradient(0deg, #2196f3 50%, transparent 50%),
    linear-gradient(0deg, #2196f3 50%, transparent 50%);
  background-repeat: repeat-x, repeat-x, repeat-y, repeat-y;
  background-size: #{$base-size - $offset}px #{$dash-line-size}px,
    #{$base-size - $offset}px #{$dash-line-size}px,
    #{$dash-line-size}px #{$base-size - $offset}px,
    #{$dash-line-size}px #{$base-size - $offset}px;
  animation: border-dance 4s infinite linear;
}
@keyframes border-dance {
  0% {
    background-position: 0px 0px, 150px 50px, 0px 150px, 50px 0px;
  }
  100% {
    background-position: 150px 0px, 0px 50px, 0px 0px, 50px 150px;
  }
}
.descriptionzone {
  position: absolute;
  top: 64px;
  left: 0px;
  width: 160px;
  font-size: 12px;
  line-height: 12px;
  z-index: -1;
}
@keyframes tbeat {
  from {
    transform: scale(0.8);
  }
  to {
    transform: scale(1.2);
  }
}
.heartbeat {
  animation: tbeat 0.5s infinite alternate;
  transform-origin: center;
}
.selected.heartbeat {
  animation: border-dance 4s infinite linear, tbeat 0.5s infinite alternate;
}
</style>

<script>
import _ from 'lodash'

import { mapState, mapGetters } from 'vuex'

import {
  workflow_brick_size,
  extended_dict_size,
  extended_dict_values,
  extended_dict_keys,
  // is_dispatch_parametrized,
} from '@/utils.js'
import { icon_from_name, color_from_name } from './workflow_common.js'

import { subscription_mixin, brick_mixin } from '@/components/mixin.js'
import { WorkflowCanvasBrickHandler } from './workflow_core.vue'

// *****************************************************************************

export default {
  name: 'WorkflowCanvasBrick',
  components: {},
  mixins: [subscription_mixin, brick_mixin],
  props: ['workflow_interface', 'value', 'project_id', 'options'],
  computed: {
    cur_project() {
      let res =
        (this.automl_projects_undeleted_object.projects || {})[
          this.project_id
        ] || {}
      return res
    },
    brick_name() {
      return this.value.name
    },
    progress_value() {
      let res = this.fetch_brick_progress('progress_percentage', this.value.uid)
      return res
    },
    brick_is_running() {
      return this.platform_status.current_running_brick_ids.contains(
        this.value.uid
      )
    },
    hide_progress_bar() {
      return (
        _.isEqual(this.progress_value, 100) ||
        (_.isEqual(this.progress_value, 0) && !this.brick_is_running)
      )
    },
    connector_info() {
      let selection = 0
      for (let [uid, connector_id] of [
        this.workflow_interface.drop_source,
        this.workflow_interface.drop_target,
      ]) {
        if (this.value.uid === uid) {
          // 63 = 2^6 - 1, which means all connectors highlighted
          selection = 63
        }
      }
      return icon_from_name(this.value.brick_name, selection)
    },
    symbolholderclasses() {
      let res = ['symbolholderdefault']
      if (this.brick_is_running) {
        res.push('heartbeat')
      }
      if (this.options.selected.includes(this.value.uid)) {
        res.push('selected')
      }
      let brick_color = color_from_name(this.value.brick_name)
      res.push(`synaplus-cosmo-glow-text-${brick_color}`)
      return res
    },
    holderstyle() {
      let { x, y } = this.value.position
      x -= workflow_brick_size / 2
      y -= workflow_brick_size / 2
      let style = `transform: translate(${x}px, ${y}px)`
      return style
    },
    has_description() {
      const res =
        this.value.description !== '' &&
        this.workflow_interface.show_descriptions
      return res
    },
    descriptionzoneclasses() {
      let res = ['descriptionzone']
      return res
    },

    brick_poids() {
      let res = extended_dict_values(this.value.last_poids_build_cache)
      return res
    },
    has_at_least_one_succeeded_instantiation() {
      let res = false
      if (!_.isEmpty(this.cur_project)) {
        let succeeded_poids = this.cur_project.succeeded_poids.toArray()
        let all_unique_poids = _.uniq(this.brick_poids)
        let intersect = _.intersection(all_unique_poids, succeeded_poids)
        res = !_.isEmpty(intersect)
      }
      return res
    },
    has_at_least_one_failed_instantiation() {
      let res = false
      if (!_.isEmpty(this.cur_project)) {
        let failed_poids = extended_dict_keys(
          this.cur_project.failed_poid_to_reason
        )
        let all_unique_poids = _.uniq(this.brick_poids)
        let intersect = _.intersection(all_unique_poids, failed_poids)
        res = !_.isEmpty(intersect)
      }
      return res
    },
    has_at_least_one_undecided_poid() {
      let res = false
      if (!_.isEmpty(this.cur_project)) {
        let succeeded_poids = this.cur_project.succeeded_poids.toArray()
        let failed_poids = extended_dict_keys(
          this.cur_project.failed_poid_to_reason
        )
        let decided_poids = _.concat(succeeded_poids, failed_poids)
        let all_unique_poids = _.uniq(this.brick_poids)
        let n = all_unique_poids.length

        let intersect = _.intersection(all_unique_poids, decided_poids)
        res = intersect.length !== n
      }
      return res
    },
    has_at_least_one_failed_semantic() {
      let res = false
      if (!_.isEmpty(this.cur_project)) {
        res = extended_dict_size(this.value.compute_failure_reasons) !== 0
      }
      return res
    },
    // is_not_correctly_parametrized() {
    //   let res = false
    //   if (this.value.brick_name === 'dispatch') {
    //     res = !is_dispatch_parametrized(this.value.parents_info)
    //   }
    //   // console.log(this.value.brick_name, res)
    //   return res
    // },
    // postsymbol() {
    //   let res = 'none'
    //   if (!this.value) {
    //   } else if (this.has_at_least_one_pid_instantiated) {
    //     res = 'check'
    //   } else if (this.has_at_least_one_failed_instantiation) {
    //     if (this.has_at_least_one_undecided_poid) {
    //       res = 'none'
    //     } else {
    //       res = 'cross'
    //     }
    //   }
    //   return res
    // },
    // postsymbol_addon() {
    //   let res = 'none'
    //   if (!this.value) {
    //   } else if (
    //     this.postsymbol !== 'none' &&
    //     this.is_not_correctly_parametrized
    //   ) {
    //     res = 'wait'
    //   }
    //   if (
    //     this.postsymbol === 'check' &&
    //     this.has_at_least_one_pid_instantiated &&
    //     this.has_at_least_one_failed_instantiation
    //   ) {
    //     res = 'warn'
    //   }
    //   return res
    // },
    postsymbol() {
      let res = 'none'
      if (!this.value) {
      } else if (this.has_at_least_one_succeeded_instantiation) {
        res = 'check'
      } else if (this.has_at_least_one_failed_instantiation) {
        if (this.has_at_least_one_undecided_poid) {
          res = 'none'
        } else {
          res = 'cross'
        }
      }
      return res
    },
    postsymbol_addon() {
      let res = 'none'
      if (!this.value) {
      } else if (
        this.has_at_least_one_succeeded_instantiation &&
        !this.has_at_least_one_undecided_poid
      ) {
        if (this.has_at_least_one_failed_instantiation) {
          res = 'warn'
        } else if (this.has_at_least_one_failed_semantic) {
          res = 'wait'
        }
      }
      return res
    },
    // postsymbol_addon() {
    //   let res = 'none'
    //   if (!this.value) {
    //   } else if (
    //     this.postsymbol !== 'none' &&
    //     this.is_not_correctly_parametrized
    //   ) {
    //     res = 'wait'
    //   } else if (
    //     this.postsymbol === 'check' &&
    //     this.has_at_least_one_pid_instantiated &&
    //     this.has_at_least_one_failed_instantiation
    //   ) {
    //     res = 'warn'
    //   }
    //   return res
    // },
    ...mapState(['platform_status']),
    ...mapGetters(['automl_projects_undeleted_object']),
  },
  beforeMount() {
    this.fetch_collections(['projects'])
  },
  mounted() {
    this.handler = new WorkflowCanvasBrickHandler(this)
    this.workflow_interface.install(this.handler)
  },
  beforeDestroy() {
    this.handler.stop()
    this.workflow_interface.uninstall(this.handler)
  },
  methods: {
    name_to_data(name) {
      const values = icon_from_name(name)
      Object.assign(this, values)
    },
  },
}
</script>
